import sportIds from '@/services/helpers/sports';

const {
  BASKETBALL_ID,
  FOOTBALL_ID,
  HOCKEY_ID,
  BASEBALL_ID,
  SOCCER_ID,
  TENNIS_ID,
} = sportIds;

export const generateInfoEventColumns = () => ([
  {
    id: 'startsAt',
    label: 'Time',
    columnType: 'label-icon',
    position: 0,
  },
  {
    id: 'eventName',
    label: 'Event',
    columnType: 'label-text',
    position: 1,
  },
]);

export const generateInfoPlayerColumns = () => ([
  {
    id: 'startsAt',
    label: 'Time',
    columnType: 'label-icon',
    position: 0,
  },
  {
    id: 'playerName',
    label: 'Player',
    columnType: 'label-text',
    position: 1,
  },
]);

export const generateInternalEventColumns = (client) => ([
  {
    id: 'INTERNAL_AGGREGATION',
    type: 'bookmaker-operator',
    label: 'Huddle',
    columnType: 'market',
    position: 2,
    operatorId: client,
    gateway: 'INTERNAL',
    alwaysDisplay: true,
    source: 'INTERNAL_AGGREGATION',
  },
]);

export const generateInternalClientsEventColumns = () => ([
  {
    id: 'INTERNAL_AGGREGATION',
    type: 'bookmaker-operator',
    label: 'Huddle',
    columnType: 'market',
    position: 2,
    operatorId: 'Huddle',
    source: 'INTERNAL_AGGREGATION',
    gateway: 'INTERNAL',
    alwaysDisplay: true,
  },
  {
    id: 'INTERNAL_AGGREGATION',
    type: 'bookmaker-operator',
    label: 'Betr',
    columnType: 'market',
    position: 12,
    operatorId: 'Betr',
    source: 'INTERNAL_AGGREGATION',
    isActive: true,
    gateway: 'INTERNAL',
  },
  {
    id: 'INTERNAL_AGGREGATION',
    type: 'bookmaker-operator',
    label: 'Bet Victor',
    columnType: 'market',
    position: 13,
    operatorId: 'BetVictor',
    source: 'INTERNAL_AGGREGATION',
    isActive: true,
    gateway: 'INTERNAL',
  },
  {
    id: 'INTERNAL_AGGREGATION',
    type: 'bookmaker-operator',
    label: 'Instabet',
    columnType: 'market',
    position: 14,
    operatorId: 'InstaBet',
    source: 'INTERNAL_AGGREGATION',
    isActive: true,
    gateway: 'INTERNAL',
  },
  {
    id: 'INTERNAL_AGGREGATION',
    type: 'bookmaker-operator',
    label: 'Rivalry',
    columnType: 'market',
    position: 15,
    operatorId: 'Rivalry',
    source: 'INTERNAL_AGGREGATION',
    isActive: true,
    gateway: 'INTERNAL',
  },
  {
    id: 'INTERNAL_AGGREGATION',
    type: 'bookmaker-operator',
    label: 'Superbet',
    columnType: 'market',
    position: 16,
    operatorId: 'Superbet',
    source: 'INTERNAL_AGGREGATION',
    isActive: true,
    gateway: 'INTERNAL',
  },
  {
    id: 'INTERNAL_AGGREGATION',
    type: 'bookmaker-operator',
    label: 'Tipwin',
    columnType: 'market',
    position: 17,
    operatorId: 'TipWin',
    source: 'INTERNAL_AGGREGATION',
    isActive: true,
    gateway: 'INTERNAL',
  },
  {
    id: 'INTERNAL_AGGREGATION',
    type: 'bookmaker-operator',
    label: 'Entain',
    columnType: 'market',
    position: 18,
    operatorId: 'Entain',
    source: 'INTERNAL_AGGREGATION',
    isActive: true,
    gateway: 'INTERNAL',
  },
]);

export const generateLSportsEventColumns = () => ([
  {
    id: 'FANDUEL',
    type: 'bookmaker-generic',
    label: 'Fanduel',
    columnType: 'market',
    position: 22,
    operatorId: null,
    source: 'FANDUEL',
    isActive: true,
    gateway: 'LSPORTS',
  },
  {
    id: 'DRAFTKINGS',
    type: 'bookmaker-generic',
    label: 'Draftkings',
    columnType: 'market',
    position: 23,
    operatorId: null,
    source: 'DRAFTKINGS',
    isActive: true,
    gateway: 'LSPORTS',
  },
  {
    id: 'WILLIAM_HILL',
    type: 'bookmaker-generic',
    label: 'William Hill',
    columnType: 'market',
    position: 24,
    operatorId: null,
    source: 'WILLIAM_HILL',
    isActive: true,
    gateway: 'LSPORTS',
  },
  {
    id: 'PINNACLE',
    type: 'bookmaker-generic',
    label: 'Pinnacle',
    columnType: 'market',
    position: 25,
    operatorId: null,
    source: 'PINNACLE',
    isActive: true,
    gateway: 'LSPORTS',
  },
  {
    id: 'BET_365',
    type: 'bookmaker-generic',
    label: 'Bet365',
    columnType: 'market',
    position: 26,
    operatorId: null,
    source: 'BET_365',
    isActive: true,
    gateway: 'LSPORTS',
  },
  {
    id: 'ONE_XBET',
    type: 'bookmaker-generic',
    label: '1XBet',
    columnType: 'market',
    position: 27,
    operatorId: null,
    source: 'ONE_XBET',
    isActive: true,
    gateway: 'LSPORTS',
  },
  {
    id: 'SBO',
    type: 'bookmaker-generic',
    label: 'SBO Bet',
    columnType: 'market',
    position: 29,
    operatorId: null,
    source: 'SBO',
    isActive: true,
    gateway: 'LSPORTS',
  },
  {
    id: 'UNIBET',
    type: 'bookmaker-generic',
    label: 'Unibet',
    columnType: 'market',
    position: 30,
    operatorId: null,
    source: 'UNIBET',
    isActive: true,
    gateway: 'LSPORTS',
  },
  {
    id: 'BETANO',
    type: 'bookmaker-generic',
    label: 'Betano',
    columnType: 'market',
    position: 31,
    operatorId: null,
    source: 'BETANO',
    isActive: true,
    gateway: 'LSPORTS',
  },
  {
    id: 'BETSSON',
    type: 'bookmaker-generic',
    label: 'Betsson',
    columnType: 'market',
    position: 32,
    operatorId: null,
    source: 'BETSSON',
    isActive: false,
    gateway: 'LSPORTS',
  },
  {
    id: 'ESPN_BET',
    type: 'bookmaker-generic',
    label: 'ESPN',
    columnType: 'market',
    position: 33,
    operatorId: null,
    source: 'ESPN_BET',
    isActive: false,
    gateway: 'LSPORTS',
  },
  {
    id: 'FONBET',
    type: 'bookmaker-generic',
    label: 'Fonbet',
    columnType: 'market',
    position: 34,
    operatorId: null,
    source: 'FONBET',
    isActive: false,
    gateway: 'LSPORTS',
  },
  {
    id: 'MARATHON_BET',
    type: 'bookmaker-generic',
    label: 'Marathonbet',
    columnType: 'market',
    position: 35,
    operatorId: null,
    source: 'MARATHON_BET',
    isActive: false,
    gateway: 'LSPORTS',
  },
  {
    id: 'PADDY_POWER',
    type: 'bookmaker-generic',
    label: 'Paddy Power',
    columnType: 'market',
    position: 36,
    operatorId: null,
    source: 'PADDY_POWER',
    isActive: true,
    gateway: 'LSPORTS',
  },
  {
    id: 'BETFIRST',
    type: 'bookmaker-generic',
    label: 'betFIRST',
    columnType: 'market',
    position: 37,
    operatorId: null,
    source: 'BETFIRST',
    isActive: false,
    gateway: 'LSPORTS',
  },
  {
    id: 'BET_188',
    type: 'bookmaker-generic',
    label: '188Bet',
    columnType: 'market',
    position: 38,
    operatorId: null,
    source: 'BET_188',
    isActive: false,
    gateway: 'LSPORTS',
  },
  {
    id: 'BETMGM_COLORADO',
    type: 'bookmaker-generic',
    label: 'BetMGM',
    columnType: 'market',
    position: 39,
    operatorId: null,
    source: 'BETMGM_COLORADO',
    isActive: false,
    gateway: 'LSPORTS',
  },
  {
    id: 'BWIN',
    type: 'bookmaker-generic',
    label: 'Bwin',
    columnType: 'market',
    position: 40,
    operatorId: null,
    source: 'BWIN',
    isActive: false,
    gateway: 'LSPORTS',
  },
  {
    id: 'SKY_BET',
    type: 'bookmaker-generic',
    label: 'Sky Bet',
    columnType: 'market',
    position: 41,
    operatorId: null,
    source: 'SKY_BET',
    isActive: false,
    gateway: 'LSPORTS',
  },
  {
    id: 'TIPICO',
    type: 'bookmaker-generic',
    label: 'Tipico',
    columnType: 'market',
    position: 42,
    operatorId: null,
    source: 'TIPICO',
    isActive: false,
    gateway: 'LSPORTS',
  },
]);

export const generateCoreMarkets = () => ({
  [SOCCER_ID]: [
    {
      id: 'RESULT',
      label: 'Match winner',
      selections: 3,
    },
    {
      id: 'GOAL_OVER_UNDER',
      label: 'Total goals',
      selections: 2,
    },
    {
      id: 'GOAL_HANDICAP',
      label: 'Goal handicap',
      selections: 2,
    },
    {
      id: 'HALF_RESULT',
      label: '1st half winner',
      selections: 3,
      half: 1,
    },
    {
      id: 'HALF_RESULT',
      label: '2nd half winner',
      selections: 3,
      half: 2,
    },
    {
      id: 'CORNER_OVER_UNDER',
      label: 'Total corners',
      selections: 2,
    },
    {
      id: 'HALF_CORNER_OVER_UNDER',
      label: '1st half total corners',
      selections: 2,
      half: 1,
    },
    {
      id: 'HALF_CORNER_OVER_UNDER',
      label: '2nd half total corners',
      selections: 2,
      half: 2,
    },
    {
      id: 'HALF_GOAL_HANDICAP',
      label: '1st half goal handicap',
      selections: 2,
      half: 1,
    },
    {
      id: 'HALF_GOAL_HANDICAP',
      label: '2nd half goal handicap',
      selections: 2,
      half: 2,
    },
    {
      id: 'HALF_GOAL_OVER_UNDER',
      label: '1st half total goals',
      selections: 2,
      half: 1,
    },
    {
      id: 'HALF_GOAL_OVER_UNDER',
      label: '2nd half total goals',
      selections: 2,
      half: 2,
    },
    {
      id: 'CARD_OVER_UNDER',
      label: 'Total cards',
      selections: 2,
    },
    {
      id: 'TEAM_CORNER_OVER_UNDER',
      label: 'Home team total corners',
      selections: 2,
      team: 0,
    },
    {
      id: 'TEAM_CORNER_OVER_UNDER',
      label: 'Away team total corners',
      selections: 2,
      team: 1,
    },
    {
      id: 'TEAM_CARD_OVER_UNDER',
      label: 'Home team total cards',
      selections: 2,
      team: 0,
    },
    {
      id: 'TEAM_CARD_OVER_UNDER',
      label: 'Away team total cards',
      selections: 2,
      team: 1,
    },
    {
      id: 'PENALTY_IN_A_MATCH',
      label: 'Will a penalty be awarded?',
      selections: 2,
    },
  ],
  [BASKETBALL_ID]: [
    {
      id: 'RESULT',
      label: 'Moneyline',
      selections: 2,
    },
    {
      id: 'POINT_OVER_UNDER',
      label: 'Total',
      selections: 2,
    },
    {
      id: 'POINT_HANDICAP',
      label: 'Spread',
      selections: 2,
    },
    {
      id: 'HALF_POINT_OVER_UNDER',
      label: '1st half total',
      selections: 2,
      half: 1,
    },
    {
      id: 'HALF_POINT_OVER_UNDER',
      label: '2nd half total',
      selections: 2,
      half: 2,
    },
    {
      id: 'PERIOD_POINT_OVER_UNDER',
      label: '1st quarter total',
      selections: 2,
      period: 1,
    },
    {
      id: 'PERIOD_POINT_OVER_UNDER',
      label: '2nd quarter total',
      selections: 2,
      period: 2,
    },
    {
      id: 'PERIOD_POINT_OVER_UNDER',
      label: '3rd quarter total',
      selections: 2,
      period: 3,
    },
    {
      id: 'PERIOD_POINT_OVER_UNDER',
      label: '4th quarter total',
      selections: 2,
      period: 4,
    },
    {
      id: 'HALF_POINT_HANDICAP',
      label: '1st half spread',
      selections: 2,
      half: 1,
    },
    {
      id: 'HALF_POINT_HANDICAP',
      label: '2nd half spread',
      selections: 2,
      half: 2,
    },
    {
      id: 'HALF_POINT_HANDICAP_EXC_OT',
      label: '1st half spread exc. OT',
      selections: 2,
      half: 1,
    },
    {
      id: 'HALF_POINT_HANDICAP_EXC_OT',
      label: '2nd half spread exc. OT',
      selections: 2,
      half: 2,
    },
    {
      id: 'PERIOD_POINT_HANDICAP',
      label: '1st quarter spread',
      selections: 2,
      period: 1,
    },
    {
      id: 'PERIOD_POINT_HANDICAP',
      label: '2nd quarter spread',
      selections: 2,
      period: 2,
    },
    {
      id: 'PERIOD_POINT_HANDICAP',
      label: '3rd quarter spread',
      selections: 2,
      period: 3,
    },
    {
      id: 'PERIOD_POINT_HANDICAP',
      label: '4th quarter spread',
      selections: 2,
      period: 4,
    },
    {
      id: 'PERIOD_POINT_HANDICAP_EXC_OT',
      label: '1st quarter spread exc. OT',
      selections: 3,
      period: 1,
    },
    {
      id: 'PERIOD_POINT_HANDICAP_EXC_OT',
      label: '2nd quarter spread exc. OT',
      selections: 3,
      period: 2,
    },
    {
      id: 'PERIOD_POINT_HANDICAP_EXC_OT',
      label: '3rd quarter spread exc. OT',
      selections: 3,
      period: 3,
    },
    {
      id: 'PERIOD_POINT_HANDICAP_EXC_OT',
      label: '4th quarter spread exc. OT',
      selections: 3,
      period: 4,
    },
  ],
  [HOCKEY_ID]: [
    {
      id: 'RESULT',
      label: 'Moneyline',
      selections: 2,
    },
    {
      id: 'GOAL_OVER_UNDER',
      label: 'Total',
      selections: 2,
    },
    {
      id: 'GOAL_HANDICAP',
      label: 'Spread',
      selections: 2,
    },
  ],
  [BASEBALL_ID]: [
    {
      id: 'RESULT',
      label: 'Moneyline',
      selections: 2,
    },
    {
      id: 'RUN_OVER_UNDER',
      label: 'Total',
      selections: 2,
    },
    {
      id: 'RUN_HANDICAP',
      label: 'Spread',
      selections: 2,
    },
    /* {
      id: 'AWAY_TEAM_TOTAL',
      label: 'Away Team Total',
      selections: 2,
    },
    {
      id: 'HOME_TEAM_TOTAL',
      label: 'Home Team Total',
      selections: 2,
    }, */
    {
      id: 'RESULT_AFTER',
      label: 'Winning after 5th inning',
      selections: 2,
      resultAfterX: 5,
    },
    {
      id: 'RUN_HANDICAP_AFTER',
      label: 'Run line after 5th inning',
      selections: 2,
      resultAfterX: 5,
    },
    {
      id: 'RUN_OVER_UNDER_AFTER',
      label: 'Total after 5th inning',
      selections: 2,
      resultAfterX: 5,
    },
    {
      id: 'PERIOD_RESULT',
      label: '1st inning moneyline',
      selections: 2,
      period: 1,
    },
    {
      id: 'PERIOD_RESULT',
      label: '2nd inning moneyline',
      selections: 2,
      period: 2,
    },
    {
      id: 'PERIOD_RESULT',
      label: '3rd inning moneyline',
      selections: 2,
      period: 3,
    },
    {
      id: 'PERIOD_RESULT',
      label: '4th inning moneyline',
      selections: 2,
      period: 4,
    },
    {
      id: 'PERIOD_RESULT',
      label: '5th inning moneyline',
      selections: 2,
      period: 5,
    },
    {
      id: 'PERIOD_RESULT',
      label: '6th inning moneyline',
      selections: 2,
      period: 6,
    },
    {
      id: 'PERIOD_RESULT',
      label: '7th inning moneyline',
      selections: 2,
      period: 7,
    },
    {
      id: 'PERIOD_RESULT',
      label: '8th inning moneyline',
      selections: 2,
      period: 8,
    },
    {
      id: 'PERIOD_RESULT',
      label: '9th inning moneyline',
      selections: 2,
      period: 9,
    },
    {
      id: 'PERIOD_RUN_OVER_UNDER',
      label: '1st inning total',
      selections: 2,
      period: 1,
    },
    {
      id: 'PERIOD_RUN_OVER_UNDER',
      label: '2nd inning total',
      selections: 2,
      period: 2,
    },
    {
      id: 'PERIOD_RUN_OVER_UNDER',
      label: '3rd inning total',
      selections: 2,
      period: 3,
    },
    {
      id: 'PERIOD_RUN_OVER_UNDER',
      label: '4th inning total',
      selections: 2,
      period: 4,
    },
    {
      id: 'PERIOD_RUN_OVER_UNDER',
      label: '5th inning total',
      selections: 2,
      period: 5,
    },
    {
      id: 'PERIOD_RUN_OVER_UNDER',
      label: '6th inning total',
      selections: 2,
      period: 6,
    },
    {
      id: 'PERIOD_RUN_OVER_UNDER',
      label: '7th inning total',
      selections: 2,
      period: 7,
    },
    {
      id: 'PERIOD_RUN_OVER_UNDER',
      label: '8th inning total',
      selections: 2,
      period: 8,
    },
    {
      id: 'PERIOD_RUN_OVER_UNDER',
      label: '9th inning total',
      selections: 2,
      period: 9,
    },
    {
      id: 'PERIOD_RUN_HANDICAP',
      label: '1st inning run line',
      selections: 2,
      period: 1,
    },
    {
      id: 'PERIOD_RUN_HANDICAP',
      label: '2nd inning run line',
      selections: 2,
      period: 2,
    },
    {
      id: 'PERIOD_RUN_HANDICAP',
      label: '3rd inning run line',
      selections: 2,
      period: 3,
    },
    {
      id: 'PERIOD_RUN_HANDICAP',
      label: '4th inning run line',
      selections: 2,
      period: 4,
    },
    {
      id: 'PERIOD_RUN_HANDICAP',
      label: '5th inning run line',
      selections: 2,
      period: 5,
    },
    {
      id: 'PERIOD_RUN_HANDICAP',
      label: '6th inning run line',
      selections: 2,
      period: 6,
    },
    {
      id: 'PERIOD_RUN_HANDICAP',
      label: '7th inning run line',
      selections: 2,
      period: 7,
    },
    {
      id: 'PERIOD_RUN_HANDICAP',
      label: '8th inning run line',
      selections: 2,
      period: 8,
    },
    {
      id: 'PERIOD_RUN_HANDICAP',
      label: '9th inning run line',
      selections: 2,
      period: 9,
    },
  ],
  [FOOTBALL_ID]: [
    {
      id: 'RESULT',
      label: 'Moneyline',
      selections: 2,
    },
    {
      id: 'POINT_OVER_UNDER',
      label: 'Total',
      selections: 2,
    },
    {
      id: 'POINT_HANDICAP',
      label: 'Spread',
      selections: 2,
    },
    {
      id: 'PERIOD_RESULT',
      label: '1st quarter moneyline',
      selections: 2,
      period: 1,
    },
    {
      id: 'PERIOD_RESULT',
      label: '2nd quarter moneyline',
      selections: 2,
      period: 2,
    },
    {
      id: 'PERIOD_RESULT',
      label: '3rd quarter moneyline',
      selections: 2,
      period: 3,
    },
    {
      id: 'PERIOD_RESULT',
      label: '4th quarter moneyline',
      selections: 2,
      period: 4,
    },
    {
      id: 'HALF_POINT_OVER_UNDER',
      label: '1st half total',
      selections: 2,
      half: 1,
    },
    {
      id: 'HALF_POINT_OVER_UNDER',
      label: '2nd half total',
      selections: 2,
      half: 2,
    },
    {
      id: 'PERIOD_POINT_OVER_UNDER',
      label: '1st quarter total',
      selections: 2,
      period: 1,
    },
    {
      id: 'PERIOD_POINT_OVER_UNDER',
      label: '2nd quarter total',
      selections: 2,
      period: 2,
    },
    {
      id: 'PERIOD_POINT_OVER_UNDER',
      label: '3rd quarter total',
      selections: 2,
      period: 3,
    },
    {
      id: 'PERIOD_POINT_OVER_UNDER',
      label: '4th quarter total',
      selections: 2,
      period: 4,
    },
    {
      id: 'PERIOD_POINT_OVER_UNDER_EXC_OT',
      label: '1st quarter total exc. OT',
      selections: 2,
      period: 1,
    },
    {
      id: 'PERIOD_POINT_OVER_UNDER_EXC_OT',
      label: '2nd quarter total exc. OT',
      selections: 2,
      period: 2,
    },
    {
      id: 'PERIOD_POINT_OVER_UNDER_EXC_OT',
      label: '3rd quarter total exc. OT',
      selections: 2,
      period: 3,
    },
    {
      id: 'PERIOD_POINT_OVER_UNDER_EXC_OT',
      label: '4th quarter total exc. OT',
      selections: 2,
      period: 4,
    },
    {
      id: 'HALF_POINT_HANDICAP',
      label: '1st half spread',
      selections: 2,
      half: 1,
    },
    {
      id: 'HALF_POINT_HANDICAP',
      label: '2nd half spread',
      selections: 2,
      half: 2,
    },
    {
      id: 'HALF_POINT_HANDICAP_EXC_OT',
      label: '1st half spread exc. OT',
      selections: 2,
      half: 1,
    },
    {
      id: 'HALF_POINT_HANDICAP_EXC_OT',
      label: '2nd half spread exc. OT',
      selections: 2,
      half: 2,
    },
    {
      id: 'PERIOD_POINT_HANDICAP',
      label: '1st quarter spread',
      selections: 2,
      period: 1,
    },
    {
      id: 'PERIOD_POINT_HANDICAP',
      label: '2nd quarter spread',
      selections: 2,
      period: 2,
    },
    {
      id: 'PERIOD_POINT_HANDICAP',
      label: '3rd quarter spread',
      selections: 2,
      period: 3,
    },
    {
      id: 'PERIOD_POINT_HANDICAP',
      label: '4th quarter spread',
      selections: 2,
      period: 4,
    },
    {
      id: 'PERIOD_POINT_HANDICAP_EXC_OT',
      label: '1st quarter spread exc. OT',
      selections: 2,
      period: 1,
    },
    {
      id: 'PERIOD_POINT_HANDICAP_EXC_OT',
      label: '2nd quarter spread exc. OT',
      selections: 2,
      period: 2,
    },
    {
      id: 'PERIOD_POINT_HANDICAP_EXC_OT',
      label: '3rd quarter spread exc. OT',
      selections: 2,
      period: 3,
    },
    {
      id: 'PERIOD_POINT_HANDICAP_EXC_OT',
      label: '4th quarter spread exc. OT',
      selections: 2,
      period: 4,
    },
  ],
  [TENNIS_ID]: [
    {
      id: 'RESULT',
      label: 'Match winner',
      selections: 2,
    },
    {
      id: 'GAME_OVER_UNDER',
      label: 'Total games',
      selections: 2,
    },
    {
      id: 'GAME_HANDICAP',
      label: 'Game handicap',
      selections: 2,
    },
    /* {
      id: 'HOME_TEAM_FIRST_SERVICE_GAME_RESULT',
      label: 'Home Team First Service Game Result',
      selections: 2,
    },
    {
      id: 'AWAY_TEAM_FIRST_SERVICE_GAME_RESULT',
      label: 'Away Team First Service Game Result',
      selections: 2,
    },
    {
      id: 'HOME_TEAM_TOTAL_ACES',
      label: 'Home Team Total Aces',
      selections: 2,
    },
    {
      id: 'AWAY_TEAM_TOTAL_ACES',
      label: 'Away Team Total Aces',
      selections: 2,
    },
    {
      id: 'HOME_TEAM_DOUBLE_FAULTS',
      label: 'Home Team Double Faults',
      selections: 2,
    },
    {
      id: 'AWAY_TEAM_DOUBLE_FAULTS',
      label: 'Away Team Double Faults',
      selections: 2,
    }, */
  ],
});

export const generatePlayerFilterMarkets = () => ({
  [FOOTBALL_ID]: [
    {
      id: 'PLAYER_PASSING_ATTEMPTS_OVER_UNDER',
      label: 'Passing attempts',
      selections: 2,
    },
    {
      id: 'PLAYER_PASSING_COMPLETIONS_OVER_UNDER',
      label: 'Passing completions',
      selections: 2,
    },
    {
      id: 'PLAYER_PASSING_TOUCHDOWNS_OVER_UNDER',
      label: 'Passing TD',
      selections: 2,
    },
    {
      id: 'PLAYER_PASSING_YARDS_OVER_UNDER',
      label: 'Passing yards',
      selections: 2,
    },
    {
      id: 'PLAYER_RECEIVING_YARDS_OVER_UNDER',
      label: 'Receiving yards',
      selections: 2,
    },
    {
      id: 'PLAYER_RECEPTIONS_OVER_UNDER',
      label: 'Receptions',
      selections: 2,
    },
    {
      id: 'PLAYER_RUSHING_AND_PASSING_YARDS_OVER_UNDER',
      label: 'Rushing and passing yards',
      selections: 2,
    },
    {
      id: 'PLAYER_RUSHING_YARDS_OVER_UNDER',
      label: 'Rushing yards',
      selections: 2,
    },
    {
      id: 'PLAYER_TOUCHDOWN_X_OR_MORE',
      label: 'X or more TD',
      selections: 2,
    },
    {
      id: 'PLAYER_FIELD_GOAL_OVER_UNDER',
      label: 'Field goals',
      selections: 2,
    },
    {
      id: 'PLAYER_ANYTIME_TOUCHDOWN_SCORER',
      label: 'Anytime touchdown scorer',
      selections: 2,
    },
  ],
  [BASKETBALL_ID]: [
    {
      id: 'PLAYER_POINT_OVER_UNDER',
      label: 'Points',
      selections: 2,
    },
    {
      id: 'PLAYER_REBOUND_OVER_UNDER',
      label: 'Rebounds',
      selections: 2,
    },
    {
      id: 'PLAYER_ASSIST_OVER_UNDER',
      label: 'Assists',
      selections: 2,
    },
    {
      id: 'PLAYER_THREE_POINTER_OVER_UNDER',
      label: 'Three pointers',
      selections: 2,
    },
    {
      id: 'PLAYER_BLOCKS_OVER_UNDER',
      label: 'Blocks',
      selections: 2,
    },
    {
      id: 'PLAYER_STEALS_OVER_UNDER',
      label: 'Steals',
      selections: 2,
    },
  ],
  [HOCKEY_ID]: [
    {
      id: 'PLAYER_POINT_OVER_UNDER',
      label: 'Points',
      selections: 2,
    },
    {
      id: 'PLAYER_GOAL_OVER_UNDER',
      label: 'Goals',
      selections: 2,
    },
    {
      id: 'PLAYER_ASSIST_OVER_UNDER',
      label: 'Assists',
      selections: 2,
    },
    {
      id: 'PLAYER_SHOTS_OVER_UNDER',
      label: 'Shots',
      selections: 2,
    },
    {
      id: 'PLAYER_ANYTIME_GOALSCORER',
      label: 'Anytime goalscorer',
      selections: 2,
    },
  ],
  [BASEBALL_ID]: [
    {
      id: 'PLAYER_BASES_OVER_UNDER',
      label: 'Bases',
      selections: 2,
    },
    {
      id: 'PLAYER_HOME_RUN',
      label: 'Home run',
      selections: 2,
    },
    {
      id: 'PLAYER_RUN_OVER_UNDER',
      label: 'Runs',
      selections: 2,
    },
    {
      id: 'PLAYER_STRIKEOUT_OVER_UNDER',
      label: 'Strikeouts',
      selections: 2,
    },
    {
      id: 'PLAYER_RBI_OVER_UNDER',
      label: 'RBI',
      selections: 2,
    },
    {
      id: 'PLAYER_SINGLES',
      label: 'Singles',
      selections: 2,
    },
    {
      id: 'PLAYER_HITS',
      label: 'Hits',
      selections: 2,
    },
  ],
  [SOCCER_ID]: [
    {
      id: 'PLAYER_ANYTIME_GOALSCORER',
      label: 'Anytime goalscorer',
      selections: 2,
    },
    {
      id: 'PLAYER_FIRST_GOALSCORER',
      label: 'First goalscorer',
      selections: 2,
    },
    {
      id: 'PLAYER_LAST_GOALSCORER',
      label: 'Last goalscorer',
      selections: 2,
    },
    {
      id: 'PLAYER_TO_SCORE_OR_ASSIST',
      label: 'Player to score or assist',
      selections: 2,
    },
    {
      id: 'PLAYER_ANYTIME_ASSIST',
      label: 'Player to get assist',
      selections: 2,
    },
    {
      id: 'PLAYER_PASSES_OVER_UNDER',
      label: 'Player total passes',
      selections: 2,
    },
    {
      id: 'PLAYER_SHOTS_OVER_UNDER',
      label: 'Player total shots',
      selections: 2,
    },
    {
      id: 'PLAYER_SHOTS_ON_TARGET_OVER_UNDER',
      label: 'Player total shots on target',
      selections: 2,
    },
    {
      id: 'PLAYER_CROSSES_OVER_UNDER',
      label: 'Player total crosses',
      selections: 2,
    },
    {
      id: 'PLAYER_TACKLES_OVER_UNDER',
      label: 'Player total tackles',
      selections: 2,
    },
    {
      id: 'PLAYER_FOULS_OVER_UNDER',
      label: 'Player total fouls',
      selections: 2,
    },
    {
      id: 'GOALIE_SAVE_OVER_UNDER',
      label: 'Goalkeeper total saves',
      selections: 2,
    },
    {
      id: 'PLAYER_TO_GET_CARD',
      label: 'Player to be booked',
      selections: 2,
    },
    {
      id: 'PLAYER_TO_GET_RED_CARD',
      label: 'Player to get red card',
      selections: 2,
    },
    {
      id: 'PLAYER_TO_GET_YELLOW_CARD',
      label: 'Player to get yellow card',
      selections: 2,
    },
  ],
});

export const oddsCheckerCoreMarketCodes = ['RESULT', 'GOAL_OVER_UNDER', 'POINT_OVER_UNDER', 'RUN_OVER_UNDER', 'GAME_OVER_UNDER',
  'GOAL_HANDICAP', 'POINT_HANDICAP', 'RUN_HANDICAP', 'GAME_HANDICAP'];

export const oddsCheckerCombinedCoreMarketCodes = (sportId) => (sportId === BASEBALL_ID
  ? ['RESULT', 'RUN_OVER_UNDER']
  : ['GOAL_OVER_UNDER', 'POINT_OVER_UNDER', 'RUN_OVER_UNDER', 'GAME_OVER_UNDER',
    'GOAL_HANDICAP', 'POINT_HANDICAP', 'RUN_HANDICAP', 'GAME_HANDICAP']);
